module.exports = __webpack_public_path__ + "img/character_reader.84ba9cfb.png";